import DateInput, { DateInputSize } from "./DateInput";

export default DateInput;
export { DateInputSize };
